<script>
  import { onMount } from "svelte";
  import Loading from "../components/Loading.svelte";
  import {
    format,
    formatDistance,
    startOfDay,
    subDays,
    addDays,
  } from "date-fns";
  import DatePicker from "../components/DatePicker.svelte";
  let loading = false;
  let errorMessage = "";
  let info = {};
  let transactions = {};
  let usage = {};
  let balanceHistory = {};
  let map;
  const accessToken =
    "pk.eyJ1IjoibWhpbmdzdG9uMiIsImEiOiJja3Q4bDh5NzkxM2FqMnZvNzNtdXNoYXZkIn0.eRFAJ2el4j3VvfC12HNbFQ";
  let page = 1;
  const today = startOfDay(new Date());
  let fromDate = subDays(today, 7);
  let toDate = today;
  let usageChart;
  let transactionsChart;
  let balanceHistoryChart;

  onMount(async () => {
    await load();
  });

  async function load(refresh) {
    try {
      loading = true;

      if (!refresh) {
        await getInfo();
      }
      await getBalanceHistory(fromDate, toDate);
      await getUsage(fromDate, toDate);
    } catch (ex) {
      console.log(ex);
      if (!refresh) {
        //location.href = "/login";
      }

      console.log(ex);
    }

    loading = false;
  }

  function getAmount(inputString) {
    const pattern = /(-?(?:,*[\d]+,*[\d]*)+\.?\d*)/;
    const match = inputString.match(pattern);
    let balance = 0;

    if (match != null) {
      const input = match[0].replace(",", "");
      balance = parseFloat(input);
    }

    return balance;
  }

  async function getInfo() {
    let response;

    try {
      const response = await fetch(`${window.API_URL}/api/Meter/Info`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {

        if (response.status == 401 || response.status == 403) {
          location.href = "/login";
        } else {

        const text = await response.text();
        throw new Error(text);
        }
      }

      errorMessage = "";
      info = await response.json();
      map = L.map("map").setView([info.latitude, info.longitude], 13);
      L.marker([info.latitude, info.longitude]).addTo(map);
      L.tileLayer(
        `https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${accessToken}`,
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/streets-v11",
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
        }
      ).addTo(map);
    } catch (ex) {
      errorMessage = ex.message;
      throw ex;
    }
  }

  async function getBalanceHistory(fromDate, toDate) {
    let response;

    console.log("from date" + fromDate);
    console.log(toDate);

    try {
      const response = await fetch(
        `${
          window.API_URL
        }/api/Meter/BalanceHistory?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text);
      }

      errorMessage = "";
      balanceHistory = await response.json();
      let xlabels = [];
      let data = [];

      if (balanceHistory.length) {
        xlabels = Array.from(
          new Set(
            balanceHistory.map((c) =>
              format(startOfDay(new Date(c.date)), "dd/MM/yyyy")
            )
          )
        );

        let currentDate;

        for (const balanceHistoryItem of balanceHistory) {
          const balanceDate = format(
            startOfDay(new Date(balanceHistoryItem.date)),
            "dd/MM/yyyy"
          );
          const balanceAmount = getAmount(
            balanceHistoryItem.balance.toString()
          );
          if (currentDate != balanceDate) {
            data.push(balanceAmount);
            currentDate = balanceDate;
          }
        }
      }

      const chartData = {
        labels: xlabels,
        datasets: [
          {
            label: "Account Balance",
            data: data,
            backgroundColor: ["rgba(20, 152, 251, 0.2)"],
            borderWidth: 1,
          },
        ],
      };

      if (!balanceHistoryChart) {
        balanceHistoryChart = new Chart(document.getElementById("balance"), {
          type: "bar",
          data: chartData,
          options: {
            scales: {
              yAxes: {
                ticks: {
                  beginAtZero: true,
                  min: 0,
                },
              },
            },
          },
        });
      } else {
        balanceHistoryChart.data = chartData;
        balanceHistoryChart.update();
      }
    } catch (ex) {
      errorMessage = ex.message;
      throw ex;
    }
  }

  async function getUsage(fromDate, toDate) {
    let response;

    try {
      const response = await fetch(
        `${
          window.API_URL
        }/api/Meter/Usage?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text);
      }

      errorMessage = "";
      usage = await response.json();

      const chartData = {
        labels: usage.map((c) => c.date.substring(0, 10)),
        datasets: [
          {
            label: "Litres Dispensed",
            data: usage.map((c) => c.litres),
            backgroundColor: ["rgba(20, 152, 251, 0.2)"],
            borderWidth: 1,
          },
        ],
      };

      if (!usageChart) {
        usageChart = new Chart(document.getElementById("usage"), {
          type: "bar",
          data: chartData,
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          },
        });
      } else {
        usageChart.data = chartData;
        usageChart.update();
      }
    } catch (ex) {
      errorMessage = ex.message;
      throw ex;
    }
  }

  async function showMinistatement() {
    let response;

    try {
      const response = await fetch(`${window.API_URL}/api/Account/Token`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const text = await response.text();

      if (!response.ok) {
        throw new Error(text);
      }

      errorMessage = "";
      location.href = `https://appmanagement.ewater.services/MiniStatement/HouseholdMeter?accountNumber=${info.accountNumber}&auth=${text}`;
    } catch (ex) {
      errorMessage = ex.message;
      throw ex;
    }
  }

  //NOT IN USE
  // async function getTransactions(page) {
  //   let response;

  //   try {
  //     const response = await fetch(
  //       `${
  //         window.API_URL
  //       }/api/Meter/BalanceHistory?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
  //       {
  //         method: "GET",
  //         mode: "cors",
  //         credentials: "include",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       const text = await response.text();
  //       throw new Error(text);
  //     }

  //     errorMessage = "";
  //     transactions = await response.json();
  //     let labels = [];
  //     let data = [];

  //     if (transactions.transactions.length) {
  //       labels = Array.from(
  //         new Set(
  //           transactions.transactions.map((c) =>
  //             format(startOfDay(new Date(c.date)), "dd/MM/yyyy")
  //           )
  //         )
  //       );
  //       let currentDate;

  //       for (const transaction of transactions.transactions) {
  //         const transactionDate = format(
  //           startOfDay(new Date(transaction.date)),
  //           "dd/MM/yyyy"
  //         );
  //         const balance = getAmount(transaction.balance);

  //         if (currentDate != transactionDate) {
  //           data.push(balance);
  //           currentDate = transactionDate;
  //         }
  //       }
  //     }

  //     const chartData = {
  //       labels: labels.reverse(),
  //       datasets: [
  //         {
  //           label: "Account Balance",
  //           data: data.reverse(),
  //           backgroundColor: ["rgba(20, 152, 251, 0.2)"],
  //           borderWidth: 1,
  //         },
  //       ],
  //     };

  //     if (!transactionsChart) {
  //       transactionsChart = new Chart(document.getElementById("balance"), {
  //         type: "bar",
  //         data: chartData,
  //         options: {
  //           scales: {
  //             y: {
  //               beginAtZero: true,
  //             },
  //           },
  //         },
  //       });
  //     } else {
  //       transactionsChart.data = chartData;
  //       transactionsChart.update();
  //     }
  //   } catch (ex) {
  //     errorMessage = ex.message;
  //     throw ex;
  //   }
  // }
</script>

{#if loading}
  <Loading />
{/if}
<div class={errorMessage ? "active modal modal-lg" : "modal modal-lg"}>
  <div class="modal-container">
    <div class="modal-body">
      <div class="content">
        {errorMessage}
      </div>
    </div>
    <div class="modal-footer">
      <button on:click={() => (errorMessage = "")} class="btn btn-primary"
        >Close</button
      >
    </div>
  </div>
</div>

<div class="container">
  <div class="columns text-center flex-center m-b-s">
    <div class="column col-4 col-xs-12">
      <h2>{info.accountNumber}</h2>
      <p>{info.householdName}</p>
      <div class="columns text-center flex-center">
        <div class="row flex-around-center">
          <div class="">
            <div class="column flex-end-center">
              <div class="tile-content">
                <button
                  on:click={() =>
                    (location.href = `https://ewater.io/h/${info.accountNumber}`)}
                  class="btn btn-lg btn-primary no-margin">Topup Account</button
                >
              </div>
            </div>
          </div>
          <div class="">
            <div class="column flex-end-center">
              <div class="tile-content">
                <button
                  on:click={showMinistatement}
                  class="btn btn-lg btn-secondary no-margin"
                  >Mini statement</button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column col-4 col-xs-12" style="padding: 0">
      <div id="map" />
    </div>
  </div>
  <div class="columns text-center flex-center">
    <div class="column col-8 col-xs-12 green">
      <div class="tile text-center">
        <div class="tile-content">
          <p class="tile-title">
            <strong>Balance:</strong><br />
            {info.balance}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="columns text-center flex-center">
    <div class="column col-8 col-xs-12 blue">
      <div class="tile text-center">
        <div class="tile-content">
          <p class="tile-title">
            <strong>Average Usage:</strong><br />
            {info.averageLitresPerMonth
              ? info.averageLitresPerMonth + "L/month"
              : "Calculation waiting for larger data sample"}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="columns text-center flex-center m-b-l">
    <div class="column col-8 col-xs-12 yellow">
      <div class="tile text-center">
        <div class="tile-content">
          <p class="tile-title">
            <strong>Estimated time until credit is depleted:</strong><br />
            {info.estimatedDateCreditRunsOut
              ? formatDistance(
                  new Date(info.estimatedDateCreditRunsOut),
                  new Date(),
                  { addSuffix: true }
                )
              : "Calculation waiting for larger data sample"}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="columns text-center flex-center m-b-m">
    <div class="column col-8 col-xs-12">
      <DatePicker
        on:update={async (value) => {
          fromDate = subDays(today, parseInt(value.detail));
          await load(true);
        }}
      />
      <canvas id="usage" />
    </div>
  </div>
  <div class="columns text-center flex-center p-b-l">
    <div class="column col-8 col-xs-12">
      <canvas id="balance" />
    </div>
  </div>
</div>

<style>
  .container {
    margin-top: 50px;
  }

  .column {
    align-self: center;
    margin-top: 8px;
  }

  .tile {
    height: 48px;
  }

  #map {
    height: 180px;
  }

  .green {
    background-color: #d5e8d4;
  }

  .blue {
    background-color: #dae8fc;
  }

  .yellow {
    background-color: #fff2cc;
  }

  canvas {
    max-height: 220px;
  }
</style>
